export default {
  "box-name": "",
  "public-btn-text1": "즉석 거래",
  "public-btn-text2": "스프레드 및 모든 제품 보기",
  screen0: {
    title: "CFD 배당금",
    desc: '알림: CFD 배당금의 수령은 귀하의 MT4 계좌의 잔액에 예금 또는 출금 형식으로 반영되며, "Dividend"이라고 기록됩니다. ',
  },
  screen1: {
    title: "안전한 거래",
  },
  screen2: {
    title: "재계가 여러분의 손 안에 있습니다",
  },
  股息调整: "배당금 조정",
  了解您在股票和指数差价合约交易中的股息调整和分配机制:
    "지수, ETF 및 주식 CFD 거래 시 배당 조정 및 분배 방식에 대해 알아보세요",
  了解指数差价合约: "지수 CDF 알아보기",
  了解股票差价合约: "주식CFDs 알아보기 ",
  股息是上市公司从利润或保留资金中定期分配给股东的资金:
    "배당은 상장기업 또는 ETF가 투자자에게 정기적으로 분배하는 수익입니다.주식, 지수, ETF 차액결제거래(CFD)에 있어 실제 배당 상황에 따라 시스템은 보유 포지션에 대해 현금 배당 조정을 자동으로 반영합니다.",
  除息日与交易优化: "배당락일과 거래 최적화",
  指数差价合约的除息日由指数提供商根据成分股设定:
    "배당락일은 지수 제공자, ETF 또는 개별 종목의 공지에 따라 결정됩니다.시스템은  당일에 롱 포지션에는 현금 배당을 지급하고, 숏 포지션에는 해당 금액을 차감합니다.사전에 배당 일정을 확인하면 포지션 및 수익 관리를 보다 효과적으로 할 수 있습니다.",
  股息调整明细: "배당금 조정 세부사항",
  差价合约交易中相关产品的股息数据:
    "CFD 거래에서 기초자산의 배당금은 매수(롱)와 매도(숏)로 구분하여 표시됩니다.",
  交易产品: "Trading Products",
  多头股息: "Long Dividends",
  空头股息: "Short Dividends",
  除息日: "Ex-dividend Dates",
  即刻交易: "거래하기",
  股息的常见问题: "배당금 관련 FAQ",
  qaList: [
    {
      q: "1. 배당금과 배당락일이 무엇인가요?",
      a: [
        "배당은 상장기업 또는 ETF가 이익이나 자산의 일부를 투자자에게 분배하는 것입니다.배당락일은 해당 자산이 공식적으로 배당을 지급하고 가격이 조정되는 날짜이며, 당일 개장 전 순자산가치(NAV)나 호가에 반영됩니다.",
        "차액결제거래(CFD) 상품에서는 지수, ETF, 주식 CFD를 불문하고 배당락이 발생하면 가격 조정이 이루어지며, 이에 따라 시스템은 보유 포지션에 대해 현금 보상 또는 차감을 진행합니다.",
      ],
    },
    {
      q: "2. 배당금 조정 시간은 언제인가요?",
      a: [
        "지수 CFD의 배당 조정은 일반적으로 배당락일(MT 시간 기준) 00:00~01:00 사이에 고객님의 MT4/MT5 거래 계좌에 반영되며, 'Dividend'로 표기됩니다. ",
        "주식 및 ETF CFD의 배당 조정은 보통 배당락일(MT 시간 기준) 16:30 이전에 MT5 거래 계좌에 반영되며, 동일하게 ‘Dividend’로 표시됩니다.",
      ],
    },
    {
      q: "3. 배당금과 지수 거래가 무슨 상관인가요?",
      a: [
        "지수 거래에서 매수(롱) 포지션일 경우, 배당금이 MT4/MT5 계좌에 입금됩니다.",
        "지수 거래에서 매도(숏) 포지션일 경우, 배당금이 MT4/MT5 계좌에서 차감됩니다.",
      ],
    },
    {
      q: "4. 배당금 조정은 어떻게 계산하나요?",
      a: [
        "매수 포지션(롱) 계산 공식: 랏 수 × 계약 규모 × 매수 배당금 금액 (지수 기준 통화로 계산)",
        "매도 포지션(숏) 계산 공식: 랏 수 × 계약 규모 × 매도 배당금 금액 (지수 기준 통화로 계산)",
      ],
    },
    {
      q: "5. 배당금 조정 계산 예시",
      a: [
        "예시 – SPXUSD (S&P 500 지수 CFD)SPXUSD의 배당락일이 2024년 10월 11일이고, 롱 포지션에 대한 배당 금액이 $0.050, 숏 포지션에 대한 금액이 –$0.050이라고 가정합니다.",

        "만약 배당락일 전날인 10월 10일 종가 기준으로 SPXUSD 1 스탠다드 랏(100 계약 단위)의 매수(롱) 포지션을 보유하고 있다면, 배당 조정은 다음과 같이 계산됩니다:",

        "배당 조정 금액 = 1(스탠다드 랏) × 100(계약 크기) × $0.050 = $5 ",

        "이 $5는 배당락일 당일(10월 11일) 00:00~01:00 (MT 시간 기준) 사이에 고객님의 MT4/MT5 계좌에 'Dividend'라는 항목으로 입금됩니다.",
        "반대로, 매도(숏) 포지션을 보유한 경우에는 동일한 금액인 $5가 계좌에서 차감되며, 마찬가지로 'Dividend'로 표시됩니다."
      ],
    },
    {
      q: "6. 주의사항",
      a: [
        "배당 조정은 지수, ETF, 주식 CFD 상품에 적용됩니다.",

        "조정 금액은 배당락일의 배당 공지, 보유 포지션 방향, 거래 수량에 따라 자동 계산되어 반영됩니다.",
        "ETF CFD의 배당 금액은 해당 ETF의 공식 공지에 따라 결정되며, 기초 자산의 변동에 따라 달라질 수 있습니다.",
        "배당 조정은 스프레드나 거래 비용에는 영향을 주지 않지만, 계좌의 순자산(NAV) 및 잔고에는 영향을 미칠 수 있습니다.",
        "특정 ETF 또는 지수의 배당 일정을 확인하시려면 [배당 조정 내역]을 확인하시거나 담당 고객 매니저에게 문의해 주세요. "
      ],
    },
  ],
};
